import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const AdvancedOptions = ({ options, onOptionsChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const timeOptions = [
    { value: 'rush_hour', label: 'Rushtid (07:00-09:00, 15:00-17:00)' },
    { value: 'day', label: 'Dagtid (09:00-15:00)' },
    { value: 'evening', label: 'Kveld (17:00-22:00)' },
    { value: 'night', label: 'Natt (22:00-07:00)' }
  ];

  const handleTimeChange = (value) => {
    onOptionsChange({ ...options, timeOfDay: value });
  };

  const handleAlternativeRoutesChange = (e) => {
    onOptionsChange({ ...options, showAlternativeRoutes: e?.target?.checked });
  };

  const handleAvoidTollsChange = (e) => {
    onOptionsChange({ ...options, avoidTolls: e?.target?.checked });
  };

  return (
    <div className="w-full">
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 bg-card border-2 border-border hover:border-muted-foreground transition-all"
        style={{ borderRadius: 'var(--radius-sm)' }}
        aria-expanded={isExpanded}
        aria-label="Toggle advanced options"
      >
        <div className="flex items-center gap-3">
          <Icon name="Settings" size={20} color="var(--color-foreground)" />
          <span className="text-sm md:text-base font-medium text-foreground">
            Avanserte alternativer
          </span>
        </div>
        <Icon
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          size={20}
          color="var(--color-muted-foreground)"
        />
      </button>
      {isExpanded && (
        <div className="mt-4 p-4 md:p-6 bg-card border-2 border-border space-y-4 md:space-y-6" style={{ borderRadius: 'var(--radius-sm)' }}>
          <div>
            <Select
              label="Tidspunkt for reise"
              description="Bompriser varierer basert på tidspunkt"
              options={timeOptions}
              value={options?.timeOfDay || 'day'}
              onChange={handleTimeChange}
            />
          </div>

          <div className="space-y-3 md:space-y-4">
            <Checkbox
              label="Vis alternative ruter"
              description="Sammenlign flere rutevalg med ulike bomkostnader"
              checked={options?.showAlternativeRoutes || false}
              onChange={handleAlternativeRoutesChange}
            />

            <Checkbox
              label="Unngå bomstasjoner"
              description="Finn ruter som minimerer eller unngår bompasseringer"
              checked={options?.avoidTolls || false}
              onChange={handleAvoidTollsChange}
            />
          </div>

          <div className="pt-4 border-t-2 border-border">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
              <div className="text-xs md:text-sm text-muted-foreground font-caption">
                Rushtidspriser kan være opptil 30% høyere enn standard dagtakster. Nattrabatter gjelder mellom 22:00 og 07:00 på de fleste bomstasjoner.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedOptions;